import React, { useEffect, useRef, useState } from 'react';
import { ExecButton } from '../../ui/ExecButton/ExecButton';
import { Title } from '../../ui/Title';
import { ListFooter } from '../ListFooter/ListFooter';
import { ListGrid } from '../ListGrid/ListGrid';
import { ListHeader } from '../ListHeader/ListHeader';
import { PanelLayout } from '../Panel/Panel';
import { SpacingCustom } from '../Spacing/SpacingCustom';
import { ListFooterInfo } from '../ListFooter/ListFooterInfo';
import { TColorRole } from '../../../types/types';
import { FlexBetween } from '../FlexBetween/FlexBetween';
import { FlexCenter } from '../FlexCenter/FlexCenter';
import { MenuButtons } from '../../shared/MenuButtons/MenuButtons';
import { ProjectPathIcon } from '../../features/TreeComposite/TreeWidget/ProjectPathIcon';

interface ISubwindowProps {
    title?: string;
    main: React.ReactNode;
    footer?: React.ReactNode;
    isSingle?: boolean;
    mainColor?: TColorRole;
    isRelative?: boolean;
    headerSettings?: boolean;
    hasHeaderNavigate?: boolean;
    execFunc?: () => void;
    navigateTo?: () => void;
    hasManu?: boolean;
    headerMenu?: React.ReactNode;
    hasProjectPath?: boolean;
}


export const Subwindow: React.FC<ISubwindowProps> = ({ headerMenu = <></>, hasProjectPath = true, hasManu = true, mainColor="white", isRelative = false, title, main, footer, execFunc, hasHeaderNavigate = false, navigateTo, isSingle = false, headerSettings = true }) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);

    const onHeaderSetting = ()=>{
        execFunc && execFunc()
    }
    
    return (
            <PanelLayout stretch color={mainColor}>
                <ListGrid isSingle={isSingle} isRelative={isRelative}>
    
                    <MenuButtons hasTop hasRight right={8} top={42} showMenu={showMenu} setShowMenu={setShowMenu}>
                        {headerMenu}
                    </MenuButtons>
                    
                    {!isSingle && (
                        <ListHeader>
                            <SpacingCustom marginTop={headerSettings ? 0.8 : 1.4} marginLeft={1.5} marginBottom={headerSettings ? 0.8 : 1.4} marginRight={0.8}>
                                <FlexBetween>
                                    <Title text={title || ''} size={'l'} />
                                    {
                                        hasManu
                                        ?
                                        <FlexCenter direction='v' position='center' gap={1} >
                                            <ProjectPathIcon hasProjectPath={hasProjectPath}/>
                                            <ExecButton hasBorder = {false} isDisabled={false} size="l" label={''} showLabel={false} iconName={'ChatBotOptions'} func={() => setShowMenu(!showMenu)} />
                                        </FlexCenter>
                                        :
                                        <FlexCenter direction='v' gap={0.5}>
                                            {headerSettings
                                            &&
                                            <ExecButton stretch isDisabled={false} size="l" label={'Settings'} showLabel={true} iconName={'Configure'} func={onHeaderSetting} />
                                            }
                                        </FlexCenter>
                                    }
                                </FlexBetween>
                            </SpacingCustom>
                        </ListHeader>
                    )}
                    {main}
                    {!isSingle && (
                        <ListFooter>
                            <ListFooterInfo>{footer}</ListFooterInfo>
                            {/* <ExecButton size='s' label={'Clear'} iconName={'Edit'} func={()=>dispatch(clearChildrens())}/> */}

                        </ListFooter>
                    )}
                </ListGrid>
            </PanelLayout>
    );
};
